import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ta-type-c',
    templateUrl: './ta-type-c.component.html',
    styleUrls: ['./ta-type-c.component.scss'],
})
export class TaTypeCComponent {
    @Input() callbackData: any;

    listBtnAction() {}
}
